import _constant from "./constants";
import { locale } from "./i18n";
import common from "./common";
import { getKey, toDate } from "./utility";

// export const validateFormFields = (data)=>{

//     const data = new FormData(form);
//     for(let name of data.keys())
//     {
//         const input = form.elements[name];
//         const dataValidators = input.dataset;
//         const value = data.get(name);
//         if(dataValidators.isMandatory)
//         {
//            let error =  _constant['INPUTVALIDATOR'][_constant['MANDATORY_VALIDATION']](value);
//             if(error)
//             {
//                 return {'error':true,'element':input};
//             }
//         }
//         if(dataValidators.fixed && dataValidators.validation)
//         {
//             let validationFucntion = dataValidators.validation;
//             let error = _constant['INPUTVALIDATOR'][validationFucntion](parseInt(dataValidators.fixed),value);
//             if(error)
//             {
//                 return {'error':error,'element':input};
//             }
//         }
//         else (dataValidators.validation)
//         {
//             const validationFucntion = dataValidators.validation;
//             let minVal = dataValidators.min?dataValidators.min:1;
//             let maxVal = dataValidators.max?dataValidators.max:1;
//             let error = _constant['INPUTVALIDATOR'][validationFucntion](parseInt(minVal),parseInt(maxVal),value);
//             if(error)
//             {
//                 return {'error':error,'element':input};
//             }
//         }
//     }

// }

export const validateFormFields = formData => {
  const data = formData || [];
  const length = data.length || 0;
  let isFormError = false;
  for (let i = 0; i < length; i++) {
    const field = data[i];
    if (field.constraints) {
      if (field.constraints.isMandatoryValidation) {
        if (common.isNullOrUndefined(field.inputValue) || field.inputValue === "") {
          field.isError = true;
          field.errorName = `${field.name ? field.name : "value"} ${locale("form.required.error")}`;
          isFormError = true;
        } else if (valuePresentValidations(field)) {
          isFormError = true;
        }
      } else if (!common.isNullOrUndefined(field.inputValue) && field.inputValue !== "") {
        if (valuePresentValidations(field)) {
          isFormError = true;
        }
      }
    }
  }
  return { fields: data, isFormError };
};

let valuePresentValidations = field => {
  let isError = false;
  if (_constant.INPUT_TEXT_REGEX.test(field.inputValue)) {
    field.isError = true;
    field.errorName = `${locale("form.not.valid.value")}`;
    isError = true;
  }
  if (field.constraints && field.constraints.format && !new RegExp(field.constraints.format).test(field.inputValue)) {
    field.isError = true;
    field.errorName = `${locale("form.not.valid.value")}`;
    isError = true;
  } else if (
    field.constraints &&
    field.constraints.allowedValues &&
    Array.isArray(field.constraints.allowedValues) &&
    field.constraints.allowedValues.length > 0
  ) {
    const isDropdownAmount = getKey(field, "type", null) === _constant.CUSTOM_AMOUNT_DROPDOWN;
    let isValue = null;
    if (isDropdownAmount) {
      isValue = field.constraints.allowedValues.find(item => field.inputValue == getKey(item, "name", null));
    } else {
      isValue = field.constraints.allowedValues.find(item => field.inputValue == item);
    }
    if (!isValue) {
      field.isError = true;
      field.errorName = `${locale("form.not.allowed.value")}`;
      isError = true;
    }
  } else {
    if (field.constraints && field.constraints.minValue && field.constraints.maxValue) {
      const min = field.constraints.minValue;
      const max = field.constraints.maxValue;
      const value = field.inputValue;
      if (field.type && field.type == _constant.CUSTOM_DATE) {
        if (
          value &&
          (new Date(toDate(value)) < new Date(toDate(min)) || new Date(toDate(value)) > new Date(toDate(max)))
        ) {
          field.isError = true;
          field.errorName = `${field.name ? field.name : "value"} ${locale("form.can.be.between")} ${min} ${locale(
            "form.and"
          )} ${max}`;
          isError = true;
        }
      } else if (value && (Number(value) < Number(min) || Number(value) > Number(max))) {
        field.isError = true;
        field.errorName = `${field.name ? field.name : "value"} ${locale("form.can.be.between")} ${min} ${locale(
          "form.and"
        )} ${max}`;
        isError = true;
      }
    }
    if (field.constraints && field.constraints.minLength && field.constraints.maxLength) {
      const min = field.constraints.minLength;
      const max = field.constraints.maxLength;
      const value = field.inputValue;
      // Fixed length case
      if (min == max) {
        if (value && value.length != min) {
          field.isError = true;
          field.errorName = `${field.name ? field.name : "value"} ${locale("form.fixed.length")} ${min}`;
          isError = true;
        }
      } else if (value && (value.length < min || value.length > max)) {
        field.isError = true;
        field.errorName = `${field.name ? field.name : "value"} ${locale("form.can.be.from")} ${min} ${locale(
          "form.to"
        )} ${max} ${locale("form.character")}`;
        isError = true;
      }
    }
  }
  return isError;
};



// WEBPACK FOOTER //
// ./utils/formValidation.js